import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=6f9a8392&scoped=true&"
import script from "./Table.vue?vue&type=script&lang=js&"
export * from "./Table.vue?vue&type=script&lang=js&"
import style0 from "./Table.vue?vue&type=style&index=0&id=6f9a8392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9a8392",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductLink: require('/usr/src/motec/components/product/Link.vue').default,ProductAttributeValueNumberOrNaN: require('/usr/src/motec/components/product/AttributeValue/NumberOrNaN.vue').default,ProductAttributeValueBoolean: require('/usr/src/motec/components/product/AttributeValue/Boolean.vue').default})
